<template>
    <div class="bg-white rounded-lg shadow p-4">
        <h3 class="text-sm font-medium text-gray-700 mb-3">분류 기준</h3>
        <div class="relative overflow-hidden rounded-lg bg-gray-100 p-1">
            <div class="flex gap-1 relative z-10">
                <button @click="selectGroupType('BOND_TYPE')" :class="[
                    'flex-1 px-4 py-2 text-sm font-medium rounded-md transition-colors relative z-10',
                    modelValue === 'BOND_TYPE'
                        ? 'text-white'
                        : 'text-gray-700 hover:text-gray-900',
                ]">
                    섹터별
                </button>
                <button @click="selectGroupType('INSTITUTION_TYPE')" :class="[
                    'flex-1 px-4 py-2 text-sm font-medium rounded-md transition-colors relative z-10',
                    modelValue === 'INSTITUTION_TYPE'
                        ? 'text-white'
                        : 'text-gray-700 hover:text-gray-900',
                ]">
                    기관별
                </button>
            </div>
            <!-- 슬라이딩 배경 -->
            <div class="absolute top-1 bottom-1 transition-all duration-300 ease-in-out bg-gray-800 rounded-md" :style="{
                left: modelValue === 'BOND_TYPE' ? '4px' : '50%',
                right: modelValue === 'BOND_TYPE' ? '50%' : '4px',
            }"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GroupTypeSelector',
    props: {
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const selectGroupType = type => {
            emit('update:modelValue', type);
        };

        return {
            selectGroupType,
        };
    },
};
</script>
